import { cn } from '@/utils/tailwind-util'
import * as React from 'react'

interface SelectableRowProps extends React.ComponentPropsWithoutRef<'div'> {
  checked?: boolean
  disabled?: boolean
  onCheckChange?: (checked: boolean) => void
  children: React.ReactNode
  useNavigation?: boolean
}

const SelectableRow = React.forwardRef<HTMLDivElement, SelectableRowProps>(
  ({ checked, disabled, onCheckChange, children, className, useNavigation = false, ...props }, ref) => {
    const handleToggle = () => {
      if (disabled) return
      onCheckChange?.(!checked)
    }
    return (
      <div
        ref={ref}
        role="button"
        tabIndex={useNavigation ? 0 : -1}
        aria-checked={checked}
        aria-disabled={disabled}
        className={cn(
          'flex items-center justify-between p-3 border rounded-xl transition-colors cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          checked ? 'bg-primary/10 border-primary/30' : 'hover:bg-muted/50',
          className,
        )}
        onClick={handleToggle}
        onKeyDown={(e) => {
          if (!useNavigation) return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleToggle()
          }
        }}
        {...props}
      >
        {children}
      </div>
    )
  },
)
SelectableRow.displayName = 'SelectableRow'

export { SelectableRow }
